<script setup>
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import MultiselectDropdown from 'shared/components/ui/MultiselectDropdown.vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';

const { t } = useI18n();

const props = defineProps({
  modelValue: { type: Object, default: () => ({}) },
});
const emit = defineEmits(['update:modelValue']);

const store = useStore();
const allCampaigns = useMapGetter('campaigns/getAllCampaigns');

onMounted(() => store.dispatch('campaigns/get'));

const options = computed(() =>
  allCampaigns.value.map(c => ({ id: c.id, name: c.title }))
);

const selectedItem = computed(() =>
  options.value.find(o => o.id === props.modelValue?.campaign_id) ?? null
);
</script>

<template>
  <div class="multiselect-wrap--small flex flex-col gap-1.5">
    <span class="text-sm font-medium text-n-slate-12">{{ t('FLOW_BUILDER.ACTION_FORMS.SEND_CAMPAIGN.CAMPAIGN') }}</span>
    <MultiselectDropdown
      :options="options"
      :selected-item="selectedItem"
      :has-thumbnail="false"
      :multiselector-placeholder="t('FLOW_BUILDER.ACTION_FORMS.SEND_CAMPAIGN.SELECT_CAMPAIGN')"
      :input-placeholder="t('FLOW_BUILDER.COMMON.SEARCH')"
      @select="val => emit('update:modelValue', { ...modelValue, campaign_id: val?.id ?? null })"
    />
  </div>
</template>
